<template>
  <div class="form-data">
    <div class="date-select">
      <div class="date-select-content">
        <mk-date-picker
          v-model="dateVal"
          type="daterange"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="dateChange"
        >
        </mk-date-picker>
      </div>
      <div class="switch">
        <span>显示已删列</span>
        <mk-switch
          v-model="showAll"
          class="switch-btn"
        ></mk-switch>
      </div>
    </div>
    <div class="table-list">
      <table-list
        :form-data="handleFormData"
        need-checkbox
        :cancel-all="iCancelAll"
        @change="selectChange"
      ></table-list>
    </div>
    <!-- v-if="formData.contentList.length > 0" -->
    <div class="handle">
      <div class="tips clearfix">
        <!-- <div class="count">
          表单总数：{{ total }}
        </div> -->
        <!-- <div class="today-submit">
          今日提交表单：{{ todaySubmit }}
        </div> -->
        <div class="data-list">
          <!-- background -->
          <mk-pagination
            class="page-btn"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="total"
            :current-page="currentPage"
            @current-change="changePage"
          >
          </mk-pagination>
          <!-- <div class="info">
            10条/页
          </div> -->
          <!-- <div class="exchange-into">
            跳至
            <input
              v-model="nowPage"
              type="number"
              @keyup.enter="uploadPage"
            />
            页
          </div> -->
        </div>
      </div>
    </div>
    <div
      v-if="selectState"
      class="handle-data"
    >
      <ul>
        <li
          class="delete"
          @click="deleteData"
        >
          <i class="iconfont icon-mk-shanchu1"></i>
          <span>删除</span>
        </li>
      </ul>
      <div class="select-num">
        共选择<span>{{ selectNum }}</span>项
      </div>
      <div
        class="cancel"
        @click="cancel"
      >
        取消
      </div>
    </div>
    <!-- 删除弹窗 -->
    <mk-dialog-confirm
      :visible.sync="isShowDeleteDialog"
      title="确认要删除此内容吗"
      tip="删除后无法恢复，是否删除？"
      @on-confirm="templateFormDelete"
    />
  </div>
</template>
<script>
/**
 * 遍历时,注意表单提交子元素
 * 其中包括radio,select,input,textarea,address
 */
import tableList from './table-list.vue'
import dayjs from 'dayjs'
import { PROMOTIONAPIS } from '../../../../../api'
export default {
  components: {
    tableList
  },
  props: {
    propData: {
      type: Object,
      default () {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      iCancelAll: false,
      formId: '', // 表单formId
      showAll: false, // 是否显示删除项
      currentPage: 1, // 分页当下页
      dateVal: '',
      selectArr: [],
      selectNum: 0,
      selectState: false,
      handleShow: true,
      nowPage: 1, // 数据当下页
      exportUrl: '',
      total: 0,
      todaySubmit: 0,
      startTime: '', // 开始时间
      endTime: '', // 结束时间
      isShowDeleteDialog: false,
      formData: {
        titleList: [],
        contentList: []
      },
      allFormData: [], // 表单提交数据（包含已删项）
      partFormData: [] // 表单提交数据（未含已删项）
    }
  },
  computed: {
    handleFormData () {
      return this.formData
    }
  },
  watch: {
    showAll (val) {
      // if (val) {
      this.getFormDataList(val)
      // }
    }
  },
  created () {
    this.formId = this.$route.query.id
    this.getFormDataList()
  },
  methods: {
    async getFormDataList (showAll) {
      const res = await PROMOTIONAPIS.ContentApi.contentDetailGet({
        _id: this.$route.query.id
      })
      let arr = []
      this.allFormData = []
      this.partFormData = []
      if (res.success) {
        let data = res.data.formMeta
        if (data && data.length > 0) {
          let i = 0
          let len = data.length
          for (i; i < len; i++) {
            // type = radio,select,input,textarea,address
            if (
              data[i].type === 'radio' ||
              data[i].type === 'select' ||
              data[i].type === 'input' ||
              data[i].type === 'textarea' ||
              data[i].type === 'address'
            ) {
              if (data[i].isDelete) {
                this.allFormData.push({
                  id: data[i]._id,
                  name: data[i].config.title + '（已删）',
                  isDelete: data[i].isDelete,
                  checked: false
                })
              } else {
                this.allFormData.push({
                  id: data[i]._id,
                  name: data[i].config.title,
                  isDelete: data[i].isDelete,
                  checked: false
                })
                this.partFormData.push({
                  id: data[i]._id,
                  name: data[i].config.title,
                  isDelete: data[i].isDelete,
                  checked: false
                })
              }
            }
          }
          this.allFormData.push({
            id: 'upload',
            key: 'upload',
            name: '提交时间',
            isDelete: false
          })
          this.partFormData.push({
            id: 'upload',
            key: 'upload',
            name: '提交时间',
            isDelete: false
          })
          if (this.showAll) {
            this.titleList = this.allFormData
            this.formData.titleList = this.allFormData
          } else {
            this.titleList = this.partFormData
            this.formData.titleList = this.partFormData
          }
          this.getContentList(
            this.$route.query.id,
            this.startTime,
            this.endTime
          )
        } else {
          this.formData.titleList = [
            {
              id: 'upload',
              key: 'upload',
              name: '提交时间',
              isDelete: false
            }
          ]
          this.formData.contentList = []
        }
      }
    },
    async getContentList (id, startTime, endTime) {
      let metas = {}
      if (startTime && endTime) {
        metas = {
          _id: this.$route.query.id,
          page: this.nowPage,
          pageSize: 10,
          startTime: startTime,
          endTime: endTime
        }
      } else {
        metas = {
          _id: this.$route.query.id,
          page: this.nowPage,
          pageSize: 10
        }
      }
      const res = await PROMOTIONAPIS.ContentApi.contentFormSubmitDataPost(
        metas
      )
      if (res.success) {
        this.total = res.data.total
        // this.todaySubmit = res.data.todaySubmit || 0
        let arr = []
        let data = res.data.data
        if (data.length > 0) {
          let i = 0
          let len = data.length
          for (i; i < len; i++) {
            arr.push([])
            for (let j = 0; j < this.formData.titleList.length; j++) {
              for (let s in data[i].promotionData) {
                if (s === this.formData.titleList[j].id) {
                  arr[i][j] = {
                    key: s,
                    id: data[i].formDataID,
                    value: data[i].promotionData[s],
                    checked: false
                  }
                }
              }
            }
            arr[i].push({
              id: 'upload',
              key: 'upload',
              value: data[i].createTime
            })
          }
          this.formData.contentList = arr
        } else {
          this.formData.contentList = []
        }
      } else {
        this.formData.contentList = []
      }
    },
    deleteData () {
      this.isShowDeleteDialog = true
    },
    dateChange (e) {
      if (e === null || e === undefined || e === '') {
        this.startTime = ''
        this.endTime = ''
        this.getFormDataList(this.$route.query.id, this.startTime, this.endTime)
      } else {
        this.startTime = dayjs(e[0]).format('YYYY-MM-DD HH:mm:ss')
        this.endTime = dayjs(e[1]).format('YYYY-MM-DD') + ' 23:59:59'
        this.getFormDataList(this.formId, this.startTime, this.endTime)
      }
    },
    // 输入框enter事件
    uploadPage (e) {
      this.currentPage = Number(this.nowPage)
      this.getFormDataList(this.$route.query.id, this.showAll)
      this.selectState = false
    },
    changePage (e) {
      this.nowPage = e
      this.getFormDataList(this.formId)
    },
    // 取消选择
    cancel () {
      this.iCancelAll = true
      setTimeout(() => {
        this.iCancelAll = false
      }, 100)
      this.selectState = false
    },
    // 选择框change事件
    selectChange (e) {
      if (e.length > 0) {
        this.selectState = true
      } else {
        this.selectState = false
      }
      this.selectArr = e
      this.selectNum = e.length
    },
    // 删除数据
    async templateFormDelete () {
      this.isShowDeleteDialog = false
      if (this.selectArr.length > 0) {
        let metas = {
          _id: this.$route.query.id,
          formDataIDs: this.handleArr(this.selectArr)
        }
        const res = await PROMOTIONAPIS.ContentApi.contentFormDeleteGet(metas)
        if (res.success) {
          this.selectState = false
          this.getFormDataList(this.formId, this.startTime, this.endTime)
        }
      }
    },
    handleArr (arr) {
      let str = ''
      arr.forEach((item, index) => {
        str = str + item + ','
      })
      str = str.substring(0, str.length - 1)
      return str
    },
    beforeDestroy () {
      this.nowPage = 1
    }
  }
}
</script>
<style lang="scss" scoped>
.clearfix::after {
  content: '.';
  clear: both;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  display: block;
}

.clearfix {
  zoom: 1;
}

a {
  text-decoration: none;
  color: #595959;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.form-data {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: calc(100% - 40px);
  margin: 0 auto;
  margin-top: 20px;
  overflow-y: hidden;
  position: relative;

  .date-select {
    font-size: 16px;
    padding-bottom: 20px;
    display: flex;
    width: 100%;

    .date-select-content {
      flex: 1;
      align-self: center;
    }

    .switch {
      float: right;
      align-self: center;
      font-size: 14px;

      span {
        font-size: 14px;
        // font-family: PingFangSC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
      }

      .switch-btn {
        margin-left: 10px;
      }
    }
  }

  .table-list {
    flex: 1;
  }

  .handle {
    .tips {
      margin-bottom: 20px;
      line-height: 24px;

      .count,
      .today-submit {
        // flex-basis: 20%;
        margin-top: 20px;
        float: left;
        font-size: 14px;
        // font-family: PingFangSC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
      }

      .today-submit {
        margin-left: 20px;
      }
    }

    .data-list {
      float: right;

      .page-btn {
        float: left;
      }

      .info {
        float: left;
        width: 80px;
        height: 24px;
        box-sizing: border-box;
        border-radius: 2px;
        border: 1px solid rgba(217, 217, 217, 1);
        font-size: 14px;
        color: rgba(89, 89, 89, 1);
        text-indent: 8px;
        line-height: 24px;
        // margin-top: 3px;
      }

      .exchange-into {
        float: left;
        margin-left: 10px;
        font-size: 14px;
        line-height: 24px;
        // font-family: PingFangSC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);

        input {
          width: 48px;
          height: 24px;
          box-sizing: border-box;
          text-indent: 8px;
          margin-right: 8px;
        }
      }
    }
  }

  .handle-data {
    padding: 16px 24px;
    border: 1px solid #ccc;
    margin-top: 24px;
    display: flex;
    position: absolute;
    bottom: 0;
    // left: -24px;
    // width: calc(100% - 2px);
    left: 0;
    width: calc(100% - 50px);
    background: #fff;
    z-index: 99;

    ul {
      display: inline-flex;
      flex: 1;

      li {
        // flex: 1;
        margin-left: 24px;
        cursor: pointer;
        font-size: 14px;
        // font-family: PingFangSC;
        color: rgba(89, 89, 89, 1);
        font-weight: 400;

        i {
          font-size: 14px;
          margin-right: 6px;
        }
      }

      .first {
        margin-left: 0;
      }
    }

    .select-num {
      // display: inline-block;
      color: rgba(38, 38, 38, 1);
      font-size: 14px;

      span {
        color: #009cff;
        margin: 0 4px;
      }
    }

    .cancel {
      // display: inline-block;
      margin-left: 8px;
      cursor: pointer;
      color: #009cff;
      font-size: 14px;
      // font-family:PingFangSC;
      font-weight: 400;
    }
  }
}
</style>
